import { render, staticRenderFns } from "./i-form.vue?vue&type=template&id=19698973&scoped=true&"
import script from "./i-form.vue?vue&type=script&lang=js&"
export * from "./i-form.vue?vue&type=script&lang=js&"
import style0 from "./i-form.vue?vue&type=style&index=0&id=19698973&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19698973",
  null
  
)

export default component.exports